var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * Flash component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconFlash extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M7.05159 1.56237C7.16907 1.2851 7.44101 1.10498 7.74215 1.10498H16.3264C16.5863 1.10498 16.8277 1.23957 16.9644 1.46068C17.101 1.68179 17.1134 1.9579 16.9972 2.19039L14.4184 7.34806H19.0681C19.3714 7.35227 19.6666 7.44656 19.9162 7.61883C20.1658 7.79111 20.3586 8.03366 20.4701 8.31571C20.5816 8.59776 20.6068 8.90657 20.5425 9.20296C20.4781 9.49935 20.3272 9.76995 20.1088 9.98039L20.1043 9.98474L6.69726 22.6894C6.45191 22.9219 6.08136 22.9615 5.79238 22.7862C5.50339 22.6109 5.36738 22.2639 5.46024 21.9389L8.30862 11.9696H4.94464C4.69399 11.9683 4.44748 11.9055 4.22678 11.7867C4.00608 11.6679 3.81794 11.4967 3.6789 11.2881C3.53987 11.0796 3.45418 10.8401 3.42938 10.5906C3.40459 10.3412 3.44143 10.0895 3.53668 9.85766L3.53981 9.85004L7.05159 1.56237ZM8.2389 2.60498L4.92367 10.4289C4.92214 10.4332 4.92158 10.4377 4.92202 10.4422C4.92252 10.4472 4.92422 10.4519 4.92698 10.4561C4.92974 10.4602 4.93348 10.4636 4.93786 10.466C4.94206 10.4682 4.94675 10.4695 4.95152 10.4696H9.30292C9.53826 10.4696 9.75996 10.5801 9.90168 10.768C10.0434 10.9558 10.0887 11.1993 10.0241 11.4256L7.6558 19.7145L19.068 8.90025C19.0682 8.90001 19.0685 8.89977 19.0687 8.89952C19.0727 8.89545 19.0754 8.89036 19.0766 8.88481C19.0779 8.87893 19.0774 8.8728 19.0752 8.8672C19.0729 8.86159 19.0691 8.85678 19.0642 8.85336C19.0597 8.85027 19.0544 8.84844 19.049 8.84806H13.2048C12.9449 8.84806 12.7035 8.71347 12.5669 8.49236C12.4302 8.27124 12.4178 7.99514 12.534 7.76265L15.1129 2.60498H8.2389Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconFlash.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconFlash.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconFlash.prototype, "size", void 0);
if (customElements.get('cat-icon-flash') === undefined) {
    customElements.define('cat-icon-flash', BlocksIconFlash);
}
